import styled from 'styled-components';

import { reusableTypographyStyles } from '../styles';
import { ReusableTypographyStylesProps } from '../types';

export const StyledTitle = styled.h1<ReusableTypographyStylesProps>`
  ${reusableTypographyStyles}
`;
